import { Link } from 'react-router-dom';

interface Article {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  coverImage: string;
  date: string;
  author: string;
  views: number;
}

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 bg-background-50 rounded-lg border border-background-200 transition-all duration-300 hover:scale-[1.01] cursor-pointer"
    >
      <div className="relative w-full sm:w-48 h-32 flex-shrink-0 overflow-hidden rounded-lg">
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>
      <div className="flex flex-col justify-between flex-1 min-w-0">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
              {article.category}
            </span>
            <span className="text-xs text-foreground-500">{article.date}</span>
          </div>
          <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
            {article.title}
          </h3>
          <p className="text-xs text-foreground-600 mt-1 line-clamp-2">{article.excerpt}</p>
        </div>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-user-line"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}